import React from "react";
import { ReactRouter } from "@atlassiansox/microscopekit";
import Button from "@atlaskit/button";
import { updateURLParams } from "../utils";
export var TabLink = function (props) {
    var location = ReactRouter.useLocation();
    var history = ReactRouter.useHistory();
    var name = props.name, label = props.label, microsEnv = props.microsEnv, type = props.type, text = props.text;
    return (React.createElement(Button, { id: name + "-link", appearance: "link", onClick: function () {
            history.push("" + location.pathname + updateURLParams(location.search, [
                { name: "view", val: "detailed" },
                { name: "tab", val: name },
                { name: "label", val: label },
                { name: "env", val: microsEnv.type },
                { name: "region", val: microsEnv.region },
                { name: "envRegion", val: microsEnv.id },
                { name: "type", val: type },
            ]));
        } }, text));
};
